import React, {useEffect} from 'react';
import { Grid, Card, Typography, Box, LinearProgress } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import TaskIcon from '@mui/icons-material/Task';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getSummaryStatRequest } from './../../store/appActions';

export default function SummaryStats() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const summaryStat = useSelector((state) => state.app.summarystat || {});

  // console.log('summaryStat :',summaryStat)

  useEffect(() => {
    dispatch(getSummaryStatRequest(null));
  }, [dispatch]);

  const stats = [
    {
      title: 'Recieved Earning',
      value: `₹ ${summaryStat.earnings || 0}`,
      color: theme.palette.primary.main,
      percent: 60,
      icon: <TrendingUpIcon sx={{ fontSize: 28, color: theme.palette.primary.main }} />,
    },
    {
      title: 'Total Patients',
      value: summaryStat.totalPatients || 0,
      color: theme.palette.action?.purpleLight || theme.palette.secondary.main,
      percent: 85,
      icon: <PeopleAltIcon sx={{ fontSize: 28, color: theme.palette.action?.purpleLight || theme.palette.secondary.main }} />,
    },
    {
      title: 'Total Task',
      value: summaryStat.totalTasks || 0,
      color: theme.palette.action?.green || theme.palette.success.main,
      percent: 40,
      icon: <TaskIcon sx={{ fontSize: 28, color: theme.palette.action?.green || theme.palette.success.main }} />,
    },
    {
      title: 'Total Appointments',
      value: summaryStat.totalAppointments || 0,
      color: theme.palette.action?.red || theme.palette.error.main,
      percent: 30,
      icon: <EventAvailableIcon sx={{ fontSize: 28, color: theme.palette.action?.red || theme.palette.error.main }} />,
    },
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            sx={{
              p: 2,
              borderRadius: 2,
              boxShadow: theme.shadows[1],
              bgcolor: theme.palette.background.paper,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {stat.icon}
              <Typography variant="subtitle2" color={theme.palette.text.secondary}>
                {stat.title}
              </Typography>
            </Box>
            <Typography
              variant="h6"
              fontWeight={theme.typography.fontWeightBold}
              pl={4}
              color={theme.palette.text.primary}
              fontFamily={theme.typography.fontFamily}
            >
              {stat.value}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={stat.percent}
              sx={{
                height: 6,
                borderRadius: 5,
                backgroundColor: theme.palette.divider,
                '& .MuiLinearProgress-bar': {
                  backgroundColor: stat.color,
                },
              }}
            />
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
